/* unplugin-vue-components disabled */import script from "./list-v1.vue?vue&type=script&setup=true&lang=js"
export * from "./list-v1.vue?vue&type=script&setup=true&lang=js"

import "./list-v1.vue?vue&type=style&index=0&id=51f5c30c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f5c30c"]])

export default __exports__